"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Eraser = function (props) { return (React.createElement("svg", __assign({ "aria-hidden": "true", "data-prefix": "fas", "data-icon": "eraser", className: "eraser_svg__svg-inline--fa eraser_svg__fa-eraser eraser_svg__fa-w-16", viewBox: "0 0 512 512", width: "1em", height: "1em" }, props),
    React.createElement("path", { fill: "currentColor", d: "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 00144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z" }))); };
exports.default = Eraser;
//# sourceMappingURL=Eraser.js.map